import module from 'recursoshumanos/module.js'
import './style.scss'
import * as moment from 'moment'
import template from './template.html'

const periodo = (new Date().getFullYear())

export class RecursoshumanosPagosSuaItemComponent {
  item
  bimestral
  onSelect
  sua = null
  emision = null

  $onInit () {
    this.expandir = this.item.indicador !== 3 && this.item.notas === ''
    this.item.emision.forEach(item => {
      item.fecha = item.fechaMovimiento ? moment(item.fechaMovimiento).format(periodo === item.fechaMovimiento.getFullYear() ? 'D MMMM' : 'D MMMM YYYY') : null
      if (item.tipoMovimiento === '9') {
        item.movimiento = 'Pago'
      } else if (item.tipoMovimiento === '8') {
        item.movimiento = 'Alta'
      } else if (item.tipoMovimiento === '2') {
        item.movimiento = 'Baja'
      } else {
        item.movimiento = 'Modificación de salario'
      }
    })
  }

  insertarComentario (comentario) {
    this.item.notas = comentario
    this.current_message_nss = null
    this.expandir = false
  }

  visualizar () {
    if (this.expandir && (this.item.notas === '' && this.item.indicador !== 3)) return
    this.expandir = !this.expandir
  }

  seleccionar () {
    this.onSelect({
      $event: {
        item: this.item,
      },
    })
  }
}

module.component('recursoshumanosPagosSuaItem', {
  controller: RecursoshumanosPagosSuaItemComponent,
  template,
  bindings: {
    item: '<',
    bimestral: '<',
    onSelect: '&',
  },
})



// WEBPACK FOOTER //
// ./src/recursoshumanos/components/pagossua/lista/item/component.js